import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';

import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';
import TuneIcon from '@material-ui/icons/Tune';
import ReloadIcon from '@material-ui/icons/Replay';


import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    device: false,
    status: false,
    type: false,
    configuration: false,
    created: false,
    pageSize: 20,
};

const CommandStatus = {
    "NEW": i18n.get("commands.status.NEW"),
    "SENT": i18n.get("commands.status.SENT"),
    "DONE": i18n.get("commands.status.DONE"),
}

const CommandType = {
    "RESET": i18n.get("commands.type.RESET"),
    "DUMP": i18n.get("commands.type.DUMP"),
    "RESTART": i18n.get("commands.type.RESTART"),
    "UPDATE": i18n.get("commands.type.UPDATE"),
}

const defaultsPropertyName = 'p71.commands.defaults';

class Commands extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        switch (column) {
            case "device":
                return "uuid"
            default:
                return column;
        }
    }

    render() {



        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("commands.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            sorting: false,
                            filtering: false
                        },
                        {
                            title: i18n.get("commands.device"),
                            field: 'device',
                            hidden: this.default("device"),
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData && rowData.device ? <Chip label={rowData.device.uuid} icon={<RouterIcon/>} /> : null
                            }
                        },
                        {
                            title: i18n.get("commands.type"),
                            field: 'type',
                            hidden: this.default("type"),
                            sorting: false,
                            filtering: true,
                            lookup: CommandType,
                            render: rowData => {
                                    return rowData ? <Chip label={CommandType[rowData.type]} variant={'outlined'}  /> : null;
                            }
                        },
                        {
                            title: i18n.get("commands.status"),
                            field: 'status',
                            hidden: this.default("status"),
                            sorting: false,
                            filtering: true,
                            lookup: CommandStatus,
                            render: rowData => {
                                    return rowData ? <Chip label={CommandStatus[rowData.status]} variant={'outlined'} /> : null
                            }
                        },
                        {
                            title: i18n.get("commands.created"),
                            field: 'created',
                            hidden: this.default("created"),
                            type: "datetime",
                            comparator: 'LTE',
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("commands.configuration"),
                            field: 'configuration',
                            hidden: this.default("configuration"),
                            sorting: false,
                            filtering: false,
                            render: rowData => {
                                return rowData && rowData.configuration ? <Chip label={rowData.configuration.version} icon={<TuneIcon/>}/> : null
                            }
                        },

                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {


                                const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                const orderBy = helper.orderByString(query, this.mapField, "created")


                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        commands(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Command {
                                                    id,
                                                    device {uuid}
                                                    status,
                                                    type,
                                                    configuration {version},
                                                    created {isoString}
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.commands.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                device: element.device,
                                                status: element.status,
                                                type: element.type,
                                                configuration: element.configuration,
                                                created: element.created ? moment(element.created.isoString).toDate() : null,
                                            };
                                        }),
                                    totalCount: result.data.commands.totalCount
                                }
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("commands.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Commands.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Commands))